import React, { useEffect } from 'react';

const Login = () => {
  useEffect(() => {
    const returnTo = encodeURIComponent(window.location.origin + '/');
    window.location.replace(`https://sso.vuebillboards.com?returnTo=${returnTo}`);
  }, []);

  return (
    <div
      className="relative flex min-h-screen min-h-[100dvh] flex-col bg-slate-950 text-slate-100"
      role="main"
    >
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_120%_80%_at_50%_-20%,rgba(11,127,212,0.35),transparent_55%),radial-gradient(ellipse_80%_50%_at_100%_50%,rgba(56,189,248,0.12),transparent_45%),radial-gradient(ellipse_60%_40%_at_0%_80%,rgba(15,23,42,0.9),transparent)]"
        aria-hidden
      />
      <div className="relative z-[1] flex min-h-screen flex-1 flex-col px-6 pb-10 pt-[max(2rem,env(safe-area-inset-top))]">
        <header className="mb-10 flex justify-center" aria-label="Brand header">
          <img
            src="https://framerusercontent.com/images/s1z7JbxIyfvFvF2Gwfdjf6cEYk.png"
            alt="Vue"
            className="h-10 w-auto drop-shadow-lg md:h-12"
          />
        </header>
        <main className="flex flex-1 flex-col items-center justify-center">
          <section className="w-full max-w-md rounded-2xl border border-white/10 bg-white/[0.06] p-10 shadow-2xl shadow-black/40 backdrop-blur-md">
            <div className="flex flex-col items-center gap-4 text-center">
              <div className="ms-dots py-1">
                <span className="ms-dot bg-sky-400" />
                <span className="ms-dot bg-sky-400" />
                <span className="ms-dot bg-sky-400" />
              </div>
              <p className="text-sm font-medium text-slate-300">Redirecting to sign in…</p>
            </div>
          </section>
        </main>
        <footer
          className="mt-auto flex flex-wrap items-center justify-center gap-2 text-xs text-slate-500"
          aria-label="Legal"
        >
          <a href="/" className="transition hover:text-slate-300" onClick={(e) => e.preventDefault()}>
            Terms of use
          </a>
          <span className="text-slate-600">·</span>
          <a href="/" className="transition hover:text-slate-300" onClick={(e) => e.preventDefault()}>
            Privacy & cookies
          </a>
        </footer>
      </div>
    </div>
  );
};

export default Login;
